/**
 * Co sklep obiecuje za zapis do newslettera — konfiguracja marki
 * (app/brands/<marka>/config.ts), tutaj typy i logika czysta, testowalna bez Nuxta.
 */

export interface NewsletterDiscount {
  /** Rabat na pierwsze zamówienie, który sklep obiecuje na stałe (%) */
  percent: number
  /**
   * Czasowa podmiana na czas akcji. `until` = ISO 8601 ze strefą, koniec
   * WYŁĄCZNIE — pierwsza chwila, od której wraca `percent`. Po akcji nie trzeba
   * deployu; wpis można usunąć przy najbliższej okazji.
   */
  promo?: { percent: number, until: string }
}

/** Rabat do pokazania w chwili `now` (ms). Nieczytelna data końca = stały rabat. */
export function newsletterDiscountPercent(discount: NewsletterDiscount, now: number): number {
  const until = discount.promo ? new Date(discount.promo.until).getTime() : Number.NaN
  return discount.promo && now < until ? discount.promo.percent : discount.percent
}

interface CampaignImage {
  src: string
  width: number
  height: number
}

/**
 * Kampania na landingu `/newsletter`: grafika z reklamy, z której przychodzą
 * klienci, i jej hasło zamiast ogólnej zachęty marki.
 */
export interface NewsletterCampaign {
  /** Hasło kampanii — nagłówek strony (h1) i tytuł karty */
  title: string
  /** Zachęta pod hasłem — także opis strony */
  text: string
  /** Etykieta przycisku zapisu, bez strzałki (dokłada ją szablon) */
  cta: string
  /**
   * Tag zapisu w edrone — marketing zbiera na nim osobną grupę. Zmiana w trakcie
   * akcji rozbija grupę na dwie.
   *
   * null = front NIE wysyła zapisu do edrone, bo formularz podpina samo edrone
   * swoim kodem (integracja One-Click) — nasze zdarzenie by się z nim dublowało.
   * Ich kod czyta formularz po selektorach — patrz NewsletterSection.vue.
   */
  edroneTag: string | null
  /**
   * Grafika z reklamy: kwadrat na szerokie ekrany, pion na telefon. Grafiki mają
   * narysowany przycisk „Dołącz teraz", więc kliknięcie w nie przenosi do pola
   * e-mail. `share` = podgląd linku w social mediach i komunikatorach — JPEG,
   * bo nie każdy z nich czyta WebP.
   */
  image: { square: CampaignImage, vertical: CampaignImage, share: string, alt: string }
}
